import {
  PublishParams,
  UserFields,
  UserListParams,
} from "../../view/Modules/Users/UserDataTypes";
import AxiosInstance from "../config/axiosInterceptor";
import { ContentApiRoutes } from "../../navigation/NavConstant";

export const UserServices = {
  getUsers: (params: UserListParams) => {
    if (params.keyword !== "") {
      return AxiosInstance.get(ContentApiRoutes.USERS, {
        params,
        headers: { disableLoader: true },
      });
    }
    return AxiosInstance.get(ContentApiRoutes.USERS, { params });
  },
  getStaffList: (params: UserListParams) => {
    if (params.keyword !== "") {
      return AxiosInstance.get(ContentApiRoutes.STORE_STAVES, {
        params,
        headers: { disableLoader: true },
      });
    }
    return AxiosInstance.get(ContentApiRoutes.USERS, { params });
  },
  exportUsers: (params: UserListParams) => {
    return AxiosInstance.get(ContentApiRoutes.EXPORT_USERS, {
      params,
      responseType: "blob", // important
    }).then((response) => {
      const url = window.URL.createObjectURL(new Blob([response.data]));
      const link = document.createElement("a");
      link.href = url;
      link.setAttribute("download", "users-export.xls");
      document.body.appendChild(link);
      link.click();
    });
  },
  createUser: (data: UserFields) =>
    AxiosInstance.post(ContentApiRoutes.CREATE_USER, data),
  updateUser: (id: number, data: UserFields) =>
    AxiosInstance.post(
      ContentApiRoutes.UPDATE_USER.replace(":id", id.toString()) +
        "?_method=PUT",
      data
    ),
  publishUser: (id: number, data: PublishParams) =>
    AxiosInstance.put(
      ContentApiRoutes.PUBLISH_USER.replace(":id", id.toString()),
      data
    ),

  publishBulkUser: (ids: number[], data: PublishParams) =>
    AxiosInstance.put(ContentApiRoutes.PUBLISH_BULK_USER, {
      ...data,
      ...{ ids: ids.toString() },
    }),

  deleteUser: (id: number) =>
    AxiosInstance.delete(
      ContentApiRoutes.DELETE_USER.replace(":id", id.toString())
    ),

  deleteBulkUser: (ids: number[]) => {
    let idl = { ids: ids.toString() };
    return AxiosInstance.put(ContentApiRoutes.DELETE_BULK_USER, idl);
  },

  updatePassword: (data: object) =>
    AxiosInstance.post(ContentApiRoutes.CHANGE_PASSWORD, data),

  userLogout: () => AxiosInstance.post(ContentApiRoutes.LOGOUT),

  getLoggedInUserDetail: () =>
    AxiosInstance.get(ContentApiRoutes.LOGGED_IN_USER_DETAIL),
  getUserSettings: (params?: any) => {
    return AxiosInstance.get(ContentApiRoutes.GET_USER_SETTINGS, { params });
  },
  updateSettings: (data: object) =>
    AxiosInstance.post(ContentApiRoutes.CHANGE_USER_SETTINGS, data),

  viewUser: (id: number) => {
    return AxiosInstance.get(
      ContentApiRoutes.VIEW_USER.replace(":id", id.toString())
    );
  },

  uploadImage: (id: any, file: any) =>
    AxiosInstance.post(
      ContentApiRoutes.UPLOAD_USER_IMAGE.replace(":id", id.toString()) +
        "?_method=PUT",
      file
    ),

  updateUserProfile: (id: any, data: any) =>
    AxiosInstance.post(
      ContentApiRoutes.UPDATE_USER.replace(":id", id.toString()) +
        "?_method=PUT",
      data
    ),

  getCompanies: () => AxiosInstance.get(ContentApiRoutes.COMPANIES),

  searchCompanies: (company: string) =>
    AxiosInstance.get(ContentApiRoutes.COMPANIES + `?smart_search=${company}`, {
      cache: {
        maxAge: 30 * 60 * 1000, // 2 min instead of 15 min
        exclude: { query: false },
      },
    }),

  deleteUserImage: (id: number) =>
    AxiosInstance.post(
      ContentApiRoutes.DELETE_USER_IMAGE.replace(":id", id.toString()) +
        "?_method=PUT"
    ),
  createAddress: (data: any) =>
    AxiosInstance.post(ContentApiRoutes.CREATE_USER_ADDRESS, data),

  updateAddress: (id: number, data: any) =>
    AxiosInstance.put(
      ContentApiRoutes.UPDATE_USER_ADDRESS.replace(":id", id.toString()),
      data
    ),

  deleteAddress: (id: number) =>
    AxiosInstance.delete(
      ContentApiRoutes.DELETE_USER_ADDRESS.replace(":id", id.toString())
    ),

  checkUserNameAvailablity: (data: any) =>
    AxiosInstance.post(ContentApiRoutes.CHECK_USER_AVAILABLITY, data),
};
